import React from 'react';
import { StyleSheet, View } from 'react-native';
import CommonStyle from '../../../styles/CommonStyle';

export default function SpacerH() {
    return <View style={CommonStyle("horzSpacer")} />
}
